<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Chip" });
import "tailwindcss/tailwind.css";
export let size = "sm";
export let color = "dark";
export let css = "";
$: style = `s8-chip s8-${size} s8-${color} ${css}`;
</script>

<span class = { style }>
    <slot>Hello World</slot>
</span>


<style>

    span.s8-chip {
            position: relative;
            margin-right: 0.125rem;
            display: inline-block;
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-radius: 9999px;
}

        /* Sizes */
        span.s8-chip.s8-sm {
            font-size: 9px;
            height: 16px;
            line-height: 16px;
            padding: 0px 5px;
        }
        span.s8-chip.s8-lg {
            height: 2.125rem;
            padding-left: 0.75rem;
            padding-right: 0.75rem;
            font-size: 0.75rem;
            line-height: 2.125rem;
}
        /* Colors */
        span.s8-chip.s8-dark {
            background-color: rgba(39, 39, 17, 1);
            color: rgba(255, 255, 255, 1);
}
        span.s8-chip.s8-light {
            background-color: rgba(255, 255, 255, 1);
            color: rgba(39, 39, 17, 1);
}
        span.s8-chip.s8-neutral {
            background-color: rgba(231, 231, 230, 1);
            color: rgba(39, 39, 17, 1);
}
        span.s8-chip.s8-primary {
            background-color: rgba(161, 193, 175, 1);
            color: rgba(68, 131, 95, 1);
}</style>